export default __webpack_public_path__ + "static/media/logo_jac.018cff71.png";